import { ControlType } from "./controltype";
import { Logger } from "../logger/logger";
import { KoExtend } from "../extend/knockout-extend";

type FunctionLike<T> = T | (() => T);

interface IControlOptions {
	isReadonly?: FunctionLike<boolean>;
	maxLength?: FunctionLike<number>;
	hidden?: FunctionLike<boolean>;
}

let updateDbControlOptions = (options: any, controlType: ControlType, controlOptions: IControlOptions) => {
	if (controlOptions.isReadonly != null) {
		switch (controlType) {
			case ControlType.CheckBox:
			case ControlType.DateBox:
			case ControlType.NumberBox:
			case ControlType.DateBoxWithTime:
			case ControlType.DecimalBox:
			case ControlType.Form:
			case ControlType.RadioGroup:
			case ControlType.SearchBox:
			case ControlType.SelectBox:
			case ControlType.SelectTreeBox:
			case ControlType.TagBox:
			case ControlType.TextArea:
			case ControlType.Autocomplete:
			case ControlType.TextBox:
			case ControlType.ThreeStateCheckBox:
				options.readOnly = controlOptions.isReadonly;
				break;
			case ControlType.DataGrid:
			case ControlType.TreeList:
				if ((typeof controlOptions.isReadonly === "function" && controlOptions.isReadonly()) || controlOptions.isReadonly) {
					options.editing = { allowAdding: false, allowDeleting: false, allowUpdating: false };
					options.onEditorPreparing = (e: any) => {
						if (e.parentType !== "dataRow") {
							return;
						}

						e.cancel = true;
					};

					let oldOnToolbarPreparing = options.onToolbarPreparing;
					if (oldOnToolbarPreparing) {
						options.onToolbarPreparing = (e: any) => {
							oldOnToolbarPreparing(e);

							for (let item of e?.toolbarOptions?.items ?? []) {
								if (!item) {
									continue;
								}
								if (item.name === "columnChooserButton" || item.name === "changeLayout") {
									item.disabled = true;
									item.readOnly = true;
								}
							}
						}
					}
				}
				break;
			default:
				options.disabled = controlOptions.isReadonly;
				break;
		}
	}

	if (controlOptions.hidden != null) {
		if (ko.isObservable(controlOptions.hidden)) {
			options.visible = KoExtend.not(controlOptions.hidden as any);
		} else {
			options.visible = !controlOptions.hidden;
		}
	}

	if (controlOptions.maxLength != null) {
		switch (controlType) {
			case ControlType.TextBox:
			case ControlType.TextArea:
			case ControlType.Autocomplete:
			case ControlType.SelectBox:
			case ControlType.TagBox:
				options.maxLength = controlOptions.maxLength;
				break;

			default:
				Logger.error("Cannot apply `maxLength`", { options, controlType, controlOptions });
		}
	}

	return options;
};

let win: any = window;
win.generateDbControlOptions = (options: KnockoutObservable<any> | any, controlType: ControlType, controlOptions: IControlOptions): KnockoutComputed<any> | any => {
	if (ko.isComputed(options)) {
		return ko.pureComputed(() => {
			let curOptions = options();
			return updateDbControlOptions(curOptions, controlType, controlOptions);
		});
	} else {
		return updateDbControlOptions(options, controlType, controlOptions);
	}
};

win.generateVisible = (hiddenFlag: boolean | KnockoutObservable<boolean>): KnockoutComputed<boolean> => {
	if (hiddenFlag != null) {
		if (ko.isObservable(hiddenFlag)) {
			return KoExtend.not(hiddenFlag);
		} else {
			return ko.computed(() => !hiddenFlag);
		}
	} else {
		return ko.computed(() => true);
	}
}